import * as React from 'react';

function SvgCheckCircleSuccess(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path
        d="M40 5C20.672 5 5 20.672 5 40s15.672 35 35 35 35-15.672 35-35S59.328 5 40 5zm15.117 23.57L38.664 51.383a2.484 2.484 0 01-4.039 0l-9.742-13.5a.627.627 0 01.508-.992h3.664c.797 0 1.554.382 2.023 1.039l5.563 7.718 12.28-17.03a2.498 2.498 0 012.024-1.04h3.664c.508 0 .805.578.508.992z"
        fill="#3BC56F"
      />
    </svg>
  );
}

export default SvgCheckCircleSuccess;
